import React, {useEffect, useRef, useState} from 'react';
import PopupSelectAdapter from "../PopupSelectAdapter";
import PropTypes from "prop-types";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import PopupOptions from "../popup_select_component/PopupOptions";
import LinkForPopup from './link_implement/RecruitmentOrderingTypesPopupLinkForArticles';
import {fetchPopupData} from "../popup_select_component/fetchPopupData";
import PopupSelect from "../PopupSelect";
import ReactDOM from "react-dom";

const RecruitmentOrderingTypesRegistratorForWorkArticles = props => {
  const [recruitmentOrderingIds, setRecruitmentOrderingIds] = useState(props.recruitment_orderings_ids || "");

  const url = (() => {
    const path = '/popup/recruitment_ordering_types';
    const data = {
      selected_ids: recruitmentOrderingIds.split(","),
      is_limited_item: 0
    };
    return path + '?' + (new URLSearchParams(data)).toString();
  })();

  const onClosePopup = selectedRecruitmentOrderingTypes => {
    setRecruitmentOrderingIds(selectedRecruitmentOrderingTypes.map(sBT => sBT.id).join(','));
  };

  const onChangeRecruitmentOrderingIds = event => {
    setRecruitmentOrderingIds(event.target.value);
  };

  useEffect(() => {
    const handleCategoryChange = () => {
      const selectedRadio = document.querySelector('input[class="radio-input category"]:checked');
      if (selectedRadio && selectedRadio.value === '2') { // 選択されたラジオボタン「求職・受注記事を掲載（仕事・請負を募集する）」の場合のみ処理を実行
        setRecruitmentOrderingIds("");
      }
    };

    document.addEventListener('change', handleCategoryChange);

    return () => document.removeEventListener('change', handleCategoryChange);
  }, []);

  return (
    <>
      <PopupSelectAdapter
        popupOptions={PopupOptions.recruitmentPrTypes}
        fetchedData={fetchPopupData(url)}
        needSelectedAllButton={false}
        rootNode={document.querySelector('#popup_member_recruitment_orderings')}
        onClosePopup={onClosePopup}
        selectedNames={props.input_recruitment_ordering_name}
        LinkForPopup={LinkForPopup}
        ButtonArea={ButtonArea}
        recruitmentPrTypes={true}
      />
      <input type="hidden"
             name="work_article[work_article_recruitment_orderings_ids]"
             onChange={onChangeRecruitmentOrderingIds}
             value={recruitmentOrderingIds}
      />
    </>
  );
};

RecruitmentOrderingTypesRegistratorForWorkArticles.propTypes = {
  recruitment_ordering_ids: PropTypes.string,  // ie. "1,2,3"
  input_recruitment_ordering_name: PropTypes.string  // ie. "name1/name2/name3"
};

const ButtonArea = props => {
  return <a className="select select-recruitment_ordering-btn" onClick={props.onClickCloseButton}>選択</a>
};

export default RecruitmentOrderingTypesRegistratorForWorkArticles;
